"use client";
import React, { useContext, useState } from 'react';
import Image from 'next/image';
import heroImage from './../../public/icons/hero.png';
import Link from 'next/link';
import UserContext from '@/context/userContext';
import LoginPopUpPage from './LoginPopUp';

const HeroSection = () => {
  const context = useContext(UserContext);
  const user = context?.user;
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  // Logged out: Get Started opens the sign-up popup.
  // Logged in but not an approved author: Become an Author.
  // Logged in and an approved author: Write an Article.
  let ctaLabel = 'Become an Author';
  let ctaHref = '/become-author';
  if (user?.is_author) {
    ctaLabel = 'Write an Article';
    ctaHref = '/create-article';
  }

  return (
    <section className="hero-section">
        <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-12">
            <h1 className="hero-title">Fueling the Future:  <br />
            Your Ultimate Resource Hub for Investing</h1>
            <div className="hero-text">
                <p>
                Oil and gas have powered the world for centuries. Yet while their importance is undeniable, the path to investing in them isn’t always clear. 
                </p>
                <p>
                That’s why we’re here. Our goal is to guide you to make sense of energy investments without the jargon. With expert advice, practical tools, and real-world insights, we make investing in oil and gas easier to understand and more approachable for everyone.
                </p>
            </div>
            <div className="hero-button-wrapper">
                {user ? (
                  <Link href={ctaHref} className="btn btn-primary" style={{ textDecoration: 'none', cursor: 'pointer' }}>{ctaLabel}</Link>
                ) : (
                  <button className="btn btn-primary" style={{ cursor: 'pointer' }} onClick={() => setShowLoginPopup(true)}>Get Started</button>
                )}
            </div>
            </div>
            <div className="col-lg-12">
            <div className="hero-image-wrapper">
                <div className="hero-image-placeholder">
                <Image src={heroImage} alt="Hero Image" />
                </div>
            </div>
            </div>
        </div>
        </div>
        {showLoginPopup && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 99999, overflow: 'auto' }}>
            <LoginPopUpPage onClose={() => setShowLoginPopup(false)} initialScreen="join-invest" />
          </div>
        )}
    </section>
  );
};

export default HeroSection;